export default __webpack_public_path__ + "static/headerbilder.ikb-ca6e7eefc6841f03e7dc6147917410ff.jpg";